import type { AxiosInstance, AxiosResponse } from "axios";
import { createMetrikaGoalResolver } from "../common/helpers/metrikaGoals";
import { sendMetrikaGoal } from "../common/helpers/metrika";

/**
 * JS-цели Метрики по успешным ответам API — одним перехватчиком на axios-экземпляре.
 *
 * Ручки воронки дёргают из нескольких сторов и композаблов (проценка, корзина проценки,
 * журнал, быстрая корзина); перехватчик снимает цели в одной точке и не тащит аналитику
 * в бизнес-код. Условия достижения — `metrikaGoals.ts`, отправка — `metrika.ts`.
 *
 * Регистрировать последним: ответы, которые предыдущие перехватчики превращают в ошибку
 * (конфликт сессии, лимит запросов), сюда уже не доходят. Аналитика не должна ломать
 * работу ЛК, поэтому любая её ошибка гасится и логируется.
 */
export function installMetrikaGoalsInterceptor(instance: AxiosInstance): void {
  const resolveGoal = createMetrikaGoalResolver();

  instance.interceptors.response.use((response: AxiosResponse) => {
    try {
      const goal = resolveGoal({
        method: response.config.method ?? "",
        url: response.config.url ?? "",
        status: response.status,
        data: response.data,
      });
      if (goal) sendMetrikaGoal(goal);
    } catch (error) {
      console.error("Metrika goals interceptor error: ", error);
    }
    return response;
  });
}
